import { Stream } from "../Stream";

export class StreamTrackService {
  constructor(private stream: Stream) {}

  public restart(type: "audio" | "video") {
    const track = this.stream.getTracks().find((t) => t.kind == type);
    if (!track) return;
    track.enabled = true;
  }

  public start(element: HTMLVideoElement) {
    element.srcObject = this.stream.mediaStream;
  }

  public stop(type: "audio" | "video") {
    const track = this.stream.getTracks().find((t) => t.kind == type);
    if (!track) return;
    track.enabled = false;
  }
}
